import Vue from 'vue';
import VueI18n from 'vue-i18n';
import en from '../lang/en.json';

Vue.use(VueI18n);

/**
 * Helper function to return the language code that represents the user's favourite language.
 * this is done by returning the first element in the list of accepted languages in the user's browser settings
 * @returns String formatted "en"
 */
const getUserLanguage = () => {
  // navigator.languages is available in all modern web browsers and is generally safe to rely on.
  // It consists of an array of accepted languages formatted as such: ["en-GB", "en-US", "en"].
  // These values are managed in the browser Settings and isusually an ordered list that the user can manage.
  // If for whatever reason it is not present, it is always possible to rely on navigator.language (notice the missingg "s").
  // navigator.language is a single string in the format "en-GB" and is usually the OS language
  const browserLocales = navigator.languages === undefined ? [navigator.language] : navigator.languages;

  if (!browserLocales) {
    return 'en';
  }

  return browserLocales[0].split(/-|_/)[0] || 'en';
};

export default new VueI18n({
  locale: getUserLanguage(),
  fallbackLocale: 'en',
  messages: { en },
  silentTranslationWarn: true,
});
